import request from '@/utils/request'

const lookupBanks = () => {
  return request({
    url: '/api/lookup/banks',
    method: 'get'
  })
}

const lookupDeposit = () => {
  return request({
    url: '/api/lookup/deposit',
    method: 'get'
  })
}

const lookupConditions = () => {
  return request({
    url: '/api/lookup/conditions',
    method: 'get'
  })
}

const lookupAgreements = () => {
  return request({
    url: '/api/lookup/agreements',
    method: 'get'
  })
}

const lookupInfo = () => {
  return request({
    url: '/api/lookup/info',
    method: 'get'
  })
}

const lookupNotice = () => {
  return request({
    url: '/api/lookup/notice',
    method: 'get'
  })
}

const lookupContact = () => {
  return request({
    url: '/api/lookup/contact',
    method: 'get'
  })
}

const lookupWithdraw = () => {
  return request({
    url: '/api/lookup/withdraw',
    method: 'get'
  })
}

const lookupSlip = () => {
  return request({
    url: '/api/lookup/slip',
    method: 'get'
  })
}

const lookupSources = () => {
  return request({
    url: '/api/lookup/sources',
    method: 'get'
  })
}

const lookupActive = () => {
  return request({
    url: '/api/lookup/active',
    method: 'get'
  })
}

const lookupRegisterOTP = () => {
  return request({
    url: '/api/lookup/registerOTP',
    method: 'get'
  })
}

const lookupEnableChatWidget = () => {
  return request({
    url: '/api/lookup/enableChatWidget',
    method: 'get'
  })
}
export default {
  lookupBanks,
  lookupDeposit,
  lookupConditions,
  lookupAgreements,
  lookupInfo,
  lookupNotice,
  lookupContact,
  lookupWithdraw,
  lookupSlip,
  lookupSources,
  lookupActive,
  lookupRegisterOTP,
  lookupEnableChatWidget
}
